import {Module} from "vuex";
import {RootState} from "@/vuex/store";
import UsersState from "./state";
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const module: Module<UsersState, RootState> = {
    state: new UsersState(),
    actions,
    mutations,
    getters,
}

export default module
